/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentSplitStatusDto } from './PaymentSplitStatusDto';
import {
    PaymentSplitStatusDtoFromJSON,
    PaymentSplitStatusDtoFromJSONTyped,
    PaymentSplitStatusDtoToJSON,
    PaymentSplitStatusDtoToJSONTyped,
} from './PaymentSplitStatusDto';
import type { CardDataDto } from './CardDataDto';
import {
    CardDataDtoFromJSON,
    CardDataDtoFromJSONTyped,
    CardDataDtoToJSON,
    CardDataDtoToJSONTyped,
} from './CardDataDto';

/**
 * 
 * @export
 * @interface InhousePaymentDto
 */
export interface InhousePaymentDto {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof InhousePaymentDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    executingLocationId: number;
    /**
     * 
     * @type {InhousePaymentDtoLatestEventCodeEnum}
     * @memberof InhousePaymentDto
     */
    latestEventCode: InhousePaymentDtoLatestEventCodeEnum;
    /**
     * 
     * @type {InhousePaymentDtoLatestStateEnum}
     * @memberof InhousePaymentDto
     */
    latestState: InhousePaymentDtoLatestStateEnum;
    /**
     * 
     * @type {InhousePaymentDtoCurrencyEnum}
     * @memberof InhousePaymentDto
     */
    currency: InhousePaymentDtoCurrencyEnum;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    grossAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    terminalTipAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    grossAmountAfterAddingTerminalTip: number;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    paymentFeeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    commissionAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    netAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    refundedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    pendingRefundAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    refundableAmount: number;
    /**
     * 
     * @type {Array<PaymentSplitStatusDto>}
     * @memberof InhousePaymentDto
     */
    paymentSplitStatuses: Array<PaymentSplitStatusDto>;
    /**
     * 
     * @type {CardDataDto}
     * @memberof InhousePaymentDto
     */
    cardData?: CardDataDto;
    /**
     * 
     * @type {Date}
     * @memberof InhousePaymentDto
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof InhousePaymentDto
     */
    updated: Date;
}


/**
 * @export
 */
export const InhousePaymentDtoLatestEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type InhousePaymentDtoLatestEventCodeEnum = typeof InhousePaymentDtoLatestEventCodeEnum[keyof typeof InhousePaymentDtoLatestEventCodeEnum];

/**
 * @export
 */
export const InhousePaymentDtoLatestStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type InhousePaymentDtoLatestStateEnum = typeof InhousePaymentDtoLatestStateEnum[keyof typeof InhousePaymentDtoLatestStateEnum];

/**
 * @export
 */
export const InhousePaymentDtoCurrencyEnum = {
    NOK: 'NOK',
    DKK: 'DKK',
    SEK: 'SEK',
    GBP: 'GBP'
} as const;
export type InhousePaymentDtoCurrencyEnum = typeof InhousePaymentDtoCurrencyEnum[keyof typeof InhousePaymentDtoCurrencyEnum];


/**
 * Check if a given object implements the InhousePaymentDto interface.
 */
export function instanceOfInhousePaymentDto(value: object): value is InhousePaymentDto {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('latestEventCode' in value) || value['latestEventCode'] === undefined) return false;
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('grossAmount' in value) || value['grossAmount'] === undefined) return false;
    if (!('terminalTipAmount' in value) || value['terminalTipAmount'] === undefined) return false;
    if (!('grossAmountAfterAddingTerminalTip' in value) || value['grossAmountAfterAddingTerminalTip'] === undefined) return false;
    if (!('paymentFeeAmount' in value) || value['paymentFeeAmount'] === undefined) return false;
    if (!('commissionAmount' in value) || value['commissionAmount'] === undefined) return false;
    if (!('netAmount' in value) || value['netAmount'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    if (!('pendingRefundAmount' in value) || value['pendingRefundAmount'] === undefined) return false;
    if (!('refundableAmount' in value) || value['refundableAmount'] === undefined) return false;
    if (!('paymentSplitStatuses' in value) || value['paymentSplitStatuses'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function InhousePaymentDtoFromJSON(json: any): InhousePaymentDto {
    return InhousePaymentDtoFromJSONTyped(json, false);
}

export function InhousePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InhousePaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
        'executingLocationId': json['executingLocationId'],
        'latestEventCode': json['latestEventCode'],
        'latestState': json['latestState'],
        'currency': json['currency'],
        'grossAmount': json['grossAmount'],
        'terminalTipAmount': json['terminalTipAmount'],
        'grossAmountAfterAddingTerminalTip': json['grossAmountAfterAddingTerminalTip'],
        'paymentFeeAmount': json['paymentFeeAmount'],
        'commissionAmount': json['commissionAmount'],
        'netAmount': json['netAmount'],
        'refundedAmount': json['refundedAmount'],
        'pendingRefundAmount': json['pendingRefundAmount'],
        'refundableAmount': json['refundableAmount'],
        'paymentSplitStatuses': ((json['paymentSplitStatuses'] as Array<any>).map(PaymentSplitStatusDtoFromJSON)),
        'cardData': json['cardData'] == null ? undefined : CardDataDtoFromJSON(json['cardData']),
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
    };
}

export function InhousePaymentDtoToJSON(json: any): InhousePaymentDto {
    return InhousePaymentDtoToJSONTyped(json, false);
}

export function InhousePaymentDtoToJSONTyped(value?: InhousePaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'orderReference': value['orderReference'],
        'paymentReference': value['paymentReference'],
        'executingLocationId': value['executingLocationId'],
        'latestEventCode': value['latestEventCode'],
        'latestState': value['latestState'],
        'currency': value['currency'],
        'grossAmount': value['grossAmount'],
        'terminalTipAmount': value['terminalTipAmount'],
        'grossAmountAfterAddingTerminalTip': value['grossAmountAfterAddingTerminalTip'],
        'paymentFeeAmount': value['paymentFeeAmount'],
        'commissionAmount': value['commissionAmount'],
        'netAmount': value['netAmount'],
        'refundedAmount': value['refundedAmount'],
        'pendingRefundAmount': value['pendingRefundAmount'],
        'refundableAmount': value['refundableAmount'],
        'paymentSplitStatuses': ((value['paymentSplitStatuses'] as Array<any>).map(PaymentSplitStatusDtoToJSON)),
        'cardData': CardDataDtoToJSON(value['cardData']),
        'created': value['created'].toISOString(),
        'updated': value['updated'].toISOString(),
    };
}

